import { render, staticRenderFns } from "./MarkItemsCollectedModal.vue?vue&type=template&id=9c26e474&scoped=true"
import script from "./MarkItemsCollectedModal.vue?vue&type=script&lang=js"
export * from "./MarkItemsCollectedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c26e474",
  null
  
)

export default component.exports